import React, { useMemo } from 'react';
import {
  ClipboardList, DollarSign, BadgeCheck, TrendingUp, Banknote,
} from 'lucide-react';
import StatsCard from '../analytics/StatsCard';
import RevenueTrendChart from '../analytics/RevenueTrendChart';
import CoverDistributionChart from '../analytics/CoverDistributionChart';
import CommissionBreakdownChart from '../analytics/CommissionBreakdownChart';
import { formatCurrency } from '../../services/adminAnalyticsApi';
import '../../styles/analytics-theme.css';

const AgentBusinessAnalytics = ({ statistics = {}, charts = {} }) => {
  const monthlyTrend = useMemo(
    () => (charts.monthly || []).map((row) => ({
      month: row.month,
      premium: Number(row.premium) || 0,
      commission: Number(row.commission) || 0,
      count: Number(row.count) || 0,
    })),
    [charts.monthly]
  );

  return (
    <div className="agent-analytics-wrap">
      <div className="ab-stats-grid ab-stats-grid-5" style={{ marginBottom: '1.5rem' }}>
        <StatsCard
          title="Total Transactions"
          value={Number(statistics.totalTransactions || 0).toLocaleString()}
          subtitle="policies sold"
          icon={ClipboardList}
          variant="primary"
        />
        <StatsCard
          title="Total Revenue"
          value={formatCurrency(statistics.totalRevenue)}
          subtitle="premium collected"
          icon={DollarSign}
        />
        <StatsCard
          title="Completed Payments"
          value={Number(statistics.completedPayments || 0).toLocaleString()}
          subtitle="successful settlements"
          icon={BadgeCheck}
        />
        <StatsCard
          title="Gross Commission"
          value={formatCurrency(statistics.totalCommission)}
          subtitle="before withholding tax"
          icon={TrendingUp}
        />
        <StatsCard
          title="Net Commission"
          value={formatCurrency(statistics.netCommission)}
          subtitle={`WHT ${formatCurrency(statistics.totalTax)}`}
          icon={Banknote}
        />
      </div>

      <div className="ab-charts-grid" style={{ marginBottom: '1.5rem' }}>
        <RevenueTrendChart trendData={monthlyTrend} />
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
          <CommissionBreakdownChart
            gross={statistics.totalCommission}
            tax={statistics.totalTax}
            net={statistics.netCommission}
          />
          <CoverDistributionChart distribution={charts.coverDistribution || []} />
        </div>
      </div>
    </div>
  );
};

export default AgentBusinessAnalytics;
